import { Component, Input, OnInit } from '@angular/core';
import { MapjsService } from 'src/shared/services/mapjs.service';

import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  Validators,
} from '@angular/forms';
import {
  Alert,
  Division,
  Equipment,
  Gateway,
  GatewayManager,
} from '../map/models/mapModel';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { ErrorLibService } from 'src/shared/services/error-lib.service';
import {
  tzConvertUTC2LocalMap,
} from 'src/assets/convertTimeZone/convertTimeZone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { firstValueFrom, Subscription } from 'rxjs';
import { DateTime } from 'luxon';
import { addFavorite } from '../map/ngrx/favorite.actions';
import { mapStyleDark, mapStyleLight } from '../map/mapAssets/map.config';
import { Favorite, Installation } from '../painel-fav/painel-fav.model';
import { Favorites } from '../map/ngrx/map.reducer';
import { AuditMapFilterService } from 'src/shared/services/audit-map-filter.service';
import { AuditMapMarkerService } from 'src/shared/services/audit-map-marker.service';
import { GoogleMapsService } from 'src/shared/services/google-maps.service';
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from "@angular/material/select";
import { MatTabsModule } from "@angular/material/tabs";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
@Component({
  selector: 'app-audit-map',
  templateUrl: './audit-map.component.html',
  styleUrl: './audit-map.component.less',
  imports: [
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    MatTabsModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    TranslateModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    FormsModule,
  ],
})

export class AuditMapComponent implements OnInit {
  constructor(
    private mapjsService: MapjsService,
    private googleMapsService: GoogleMapsService,
    private formBuilder: FormBuilder,
    private errorLibService: ErrorLibService,
    private translateService: TranslateService,
    private store: Store<{ favorite: Favorites }>,
    private auditMapFilterService: AuditMapFilterService,
    private auditMapMarkerService: AuditMapMarkerService,
  ) { }

  @Input() gatewayManager: GatewayManager;

  // Funções inicialidas assim que o mapa é carregado
  public ngOnInit() {
    this.refreshAlertingInstallationsCacheForInstallations();

    // carrega o script html com a chave do Google Maps, para ficar apenas disponível na tela do mapa
    this.googleMapsService
      .loadGoogleMapsScript()
      .subscribe((success) => {
        if (success) {
          // incializa o mapa após o script com a chave do Google Maps ser adicionando no html
          this.initializeMapAfterScriptLoad();
        } else {
          console.error('Não foi possível carregar o Google Maps.');
        }
      });

    /** Caso não exista nenhum fuso horário salvo no localStorage **/
    if (this.timeZone === null) {
      /** Constante que armazena o fuso horário do sistema **/
      const systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      /** Armazena o fuso do sistema por padrão no localStorage **/
      localStorage.setItem('selectedTimeZone', systemTimeZone);
    }

    /** Limpa o id da instalação armazenado no localStorage, utilizado para filtrar os logs **/
    localStorage.removeItem('installationId');

    /** Realiza o filtro do usuário sempre que o usuário for redirecionado p/ a tela do mapa **/
    this.mapjsService.getUser(`${localStorage.getItem('username')}`);

    this.filteredGateways = this.allGateways;

    /** Caso esteja salvo a preferencia de modo escuro no local storage **/
    if (localStorage.getItem('Theme:') === 'modeDark') {
      this.themeDark = true;
    } else {
      this.themeDark = false;
    }

    this.store.select('favorite').subscribe((favorites) => {
      this.favoriteList = favorites;
    });

    let payloadInitial = {
      favorite: localStorage.getItem('favorites')
        ? JSON.parse(localStorage.getItem('favorites')!).favorites
        : {},
    };

    this.store.dispatch(addFavorite(payloadInitial));

    if (
      localStorage.getItem('selectedInstallations') &&
      JSON.parse(localStorage.getItem('selectedInstallations')!).length > 0
    ) {
      this.selectedInstallationsView = true;

      this.selectedInstallations = JSON.parse(
        localStorage.getItem('selectedInstallations')!,
      );

      /** Filtra as instalações checadas **/
      this.selectedOptions = this.selectedInstallations.filter(
        (installation: Installation) => installation.check === true,
      );
    }

    this.mapjsService.watchGateway().subscribe((type: GatewayManager) => {
      this.gatewayStatusHandler(type);
    });
  }

  /** Propriedade que armazena o fuso horário salvo no localStorage **/
  private timeZone = localStorage.getItem('selectedTimeZone');

  public ngOnDestroy() {
    /** Cancelar a subscrição do WebSocket**/
    this.mapjsService.closeConnection();

    /** Caso ocorra uma subscrição **/
    if (this.subscriptions) {
      /** Cancelar todas as susbcrições da tela do mapa**/
      this.subscriptions.unsubscribe();
    }
  }

  // Armazena o ID da empresa selecionada
  public companyId: string | null = localStorage.getItem('lastCompanySelected')
    ? localStorage.getItem('lastCompanySelected')
    : null;

  // Variavel utilizada para realizar o unsubscribe de todas as subscrições do componente
  private subscriptions: Subscription = new Subscription();

  /** Utilizado para encerrar as requisições de tipos de equipamentos e consumo **/
  public subscriptionsEquipmentConsumption: Subscription = new Subscription();

  // Endereço do google maps API Key
  private googleMapsApiKey: string = environment.googleMapsApiKeyUrl;

  // Obj map, será usado na inicialização da tela
  private map: google.maps.Map | any;

  /** Variável utilizada para manipulação do modo escuro do mapa **/
  private themeDark: boolean = false;

  // Variavel utilizada para controle dos info window com dados do websocket
  private gatewayInstallations: [] = [];

  // Lista de markers (Instalações)
  public markers: google.maps.Marker[] = [];
  // Marker selecionado pelo usuário (Variavel utilizada em diversas funções)
  private selectedMarker: google.maps.Marker;
  // Lista de marker selecionados no mapa (Concentradores)
  private gatewayMarkers: google.maps.Marker[] = [];

  //  Propriedades que sao instanciando com o Google Maps.
  private polygon: google.maps.Polygon;
  private infoWindowInstallation: google.maps.InfoWindow;
  private infoWindowGateway: google.maps.InfoWindow;

  // Listeners de eventos no mapa
  private eventClickInstallation: google.maps.MapsEventListener;
  private eventClickGateway: google.maps.MapsEventListener;
  private eventClickPreviousInstallation: google.maps.MapsEventListener;
  public eventCloseInfowindownGateway: google.maps.MapsEventListener;
  public eventClickNextInstallation: google.maps.MapsEventListener;
  public eventCloseInfowindownInstallation: google.maps.MapsEventListener;

  // Lista de concetradores
  public allGateways: Gateway[] = [];
  public filteredGateways: Gateway[] = [];

  public totalInstallations: number = 0;

  // Manipula a apresentação da sidebar de filtro
  public filterController: boolean = false;

  // Armazena o Status e últimas transmissões das instalações
  private status_lastTransmission: any = {};

  // Manipula a apresentação do loading de mais informações
  public detailConsuptionLoading: boolean = false;

  // Lista de divisões
  public allDivisions: Division[] = [];

  // Lista de equipamentos utilizada para trazer a versão do tipo de equipamento (major, minor, revision) para realizar o filtro de consumo
  public equipment: Equipment[] = [];

  /** Armazena o valor do consumo para ser exibido no infowindow das instalações no mapa **/
  public individualConsumption: string = '';

  // Armazena o tipo de filtro que será feito pelo usuário
  public choiceOptionsToView: string = 'details';

  // Recebe o valor do toggle referente ao poligono(Filtro de formas)
  public polygonSlideToggle: FormControl = new FormControl(false);

  // Manipula o estado de habilitado/desabilitado dos campos de endereço
  private polygonIsSelected: boolean = false;

  // Lista com as coordenadas do poligono
  private polygonCoords: google.maps.LatLng[] = [];

  /** Propriedade responsável por manipular quando o filtro por polígono foi realizado **/
  public installationsOnPolygons: boolean = false;

  // Manipula a apresentação do wheel na tela
  public selectedInstallations: Installation[] = [];
  public selectedOptions: Installation[] = [];

  // Manipula a apresentação da sidebar de mais informações
  public moreInfoController: boolean = false;

  // Manipula a apresentação da sidebar do modo de demonstração
  public demonstrationController: boolean = false;

  // Variável para manipular o loading do filtro de instalações por comando
  public isLoadingInstallationFilter: boolean = false;

  public showDetailsModal: boolean = false;

  // Variavel responsável por armazenar o valor escolhido pelo usuário no campo "Consultar"
  public consultValue: string = '';

  public scheduleChannel: number = 1;

  //Variáveis para manipulação do modo de demonstração
  public index: number = 0;
  public delayInSeconds = 8;
  public elementIsFound = false;

  //Utilizada para iniciar/parar o looping
  public isRunning = false;

  //Informações sobre o gateway filtrado
  public selectedGateway: any;
  public gatewayName: string = '';
  public equipmentCount: number = 0;

  // Manipula a barra de instalações selecionadas
  public selectedInstallationsView: boolean = false;

  public favoriteList: any;

  public viewFavorite: boolean = false;

  public favoriteSelected: Favorite | any;

  // Armazena o último  filtro feito(Utilizado no botão de download)
  public lastQuery: string = 'is_active=true';

  // Armazena o último  filtro feito(Utilizado para gerar o último filtro do poligono)
  private urlFilter = '';

  // Manipula a apresentação do loading de filtro por elementos
  public filterLoading: boolean = false;

  // Manipula a apresentação do loading de filtro por formas
  public filterFormsLoading: boolean = false;

  // Variaveis utilizadas para receberem os dados formatados para o filtro de alertas de consumo detalhado
  public serialNumber: string;
  public address: string;
  public lat: any;
  public long: any;
  public gateway: string;
  public alerts: Alert[] = [];

  // contador de instalações localizadas na lat e log parecidas
  public currentInstallationIndex: number = 0;

  //Armazena um array de instalações com a mesma lat e lng
  public samePlaceInstalations: google.maps.Marker[] = [];

  /** Índice rápido de markers por célula H3 (evita varrer todos os markers em cada clique). */
  private markersByClusterKey: Map<string, google.maps.Marker[]> = new Map();

  /** Cache do último conjunto de instalações em alerta (janela de 5 dias). */
  private alertingInstallations: Map<string, string> = new Map();

  // Armazena os macs dos equipamentos (utilizado para enviar os comandos ligar/desligar dentro das instalações do polígono)
  public installationMacAddress: any[] = [];

  // Armazena as instalações da rota de cadastro
  public registrationRouteInstallations: any = [];

  public installationsTransmissionRoute: any = [];

  /** Formgroup referente ao filtro do menu lateral **/
  public filterForm: FormGroup = this.formBuilder.group({
    reference: [null],
    magneticKey: [null],
    gatewayStatus: [null],
    status: [null],
    division: [null],
    gateway: [null],
    id: [null],
    street: [null],
    district: [null],
    latitude: [null],
    longitude: [null],
    serialNumber: [null],
  });

  public demonstrationForm: FormGroup = this.formBuilder.group({
    delay: [0, [Validators.min(5), Validators.required]],
  });

  /**
   * Funções assincronas
   */

  // Faz o filtro de status e últimas transmissões ao filtrar pelo modal
  public async filterStatusAndLastTrasmission(
    macs: any,
    installations: any,
    type: any,
  ) {
    let installationIds = installations.map((item: any) => item.properties.id);

    installationIds = installationIds.join(',');

    // Faz o filtro da primeira lista de macs
    this.subscriptions = this.mapjsService
      .getStatusAndLastTransmissions(
        window.atob(this.companyId!).replace(/\D/g, ''),
        installationIds,
      )
      .subscribe({
        next: async (response: any) => {
          // Armazena o resultado de cada equipamento filtrado
          Object.values(response).forEach((item: any) => {
            this.status_lastTransmission[item.mac_address] = item;
          });

          // Retira o primeiro grupo de macs da lista
          macs.shift();

          // Verifica se ainda tem grupos na lista
          if (macs.length) {
            // Se tiver, refaz o filtro com o primeiro grupo disponivel
            await this.filterStatusAndLastTrasmission(
              macs,
              installations,
              type,
            );
          } else {
            this.makeMarkers(installations, 'elements');
          }
        },
        error: (error) => {
          // Envia uma mensagem de warning ao usuário
          if (!this.isRunning) {
            Swal.fire({
              icon: 'warning',
              title: this.translateService.instant(
                'map.warning-status-lastTransmission-label',
              ),
              text: this.translateService.instant(
                'map.warning-status-lastTransmission-text',
              ),
            });
          }

          setTimeout(() => {
            this.makeMarkers(installations, 'elements');
          }, 100);

          console.log('Error', error);
        },
      });
  }

  private async refreshAlertingInstallationsCacheForInstallations(): Promise<void> {
    try {
      if (!this.companyId) return;

      const end = DateTime.utc();
      const start = end.minus({ days: 5 });
      const firstAlertDateTime = start.toISO();
      const lastAlertDateTime = end.toISO();
      if (!firstAlertDateTime || !lastAlertDateTime) return;

      const company = this.companyId!;

      const res: any = await firstValueFrom(
        this.mapjsService.getAlertsInRange({
          company,
          firstAlertDateTime,
          lastAlertDateTime,
          limit: 20000,
          offset: 0,
        }).valueChanges,
      );

      const edges = res?.data?.alert?.edges ?? [];
      edges.forEach((edge: any) => {
        const ref = edge?.node?.installationReference;
        const mac = edge?.node?.deviceMacAddress;
        const status = edge?.node?.alertState;
        if (status == 'ALERTA') {
          this.alertingInstallations.set(ref, mac);
        }
      });
    } catch (e) {
      // Em caso de falha, apenas mantém o cache vazio para não bloquear o mapa.
      this.alertingInstallations = new Map();
      console.log('Error loading alerts range', e);
    }
  }

  /** Método utilizado para retornar o marker selecionado **/
  public getselectedMarker() {
    return this.selectedMarker;
  }

  /** Método utilizado para alterar o tema do mapa para modo claro ou escuro **/
  public changeMapTheme() {
    /** Inverte o resultado para o usuário alternar entre modo escuro/claro **/
    this.themeDark = !this.themeDark;

    // Filtra todas as divisões para poderem ser utilizadas como filtro de instalações
    this.getAllDivisions();

    // Filtra todos os concetradores para poderem ser utilizados como filtro de instalações
    this.getGateways();

    this.filteredGateways = this.allGateways;

    /** Altera o mapa para o tema escuro **/
    this.map = new google.maps.Map(document.getElementById('map')!, {
      zoom: 15,
      minZoom: 2,
      center: new google.maps.LatLng(-25.419736312579452, -49.26531751521734),
      styles: this.themeDark ? mapStyleDark : mapStyleLight,
      mapTypeControl: true, // false Remove os botões de tipo de mapa
      zoomControl: false, // Remover os botões de zoom
      fullscreenControl: false, // Remove o botão de tela cheia
    });

    /** Variável utilizada para manipular quando a label deverá ser exibida **/
    let labelVisible = false;

    // Adiciona um ouvinte de evento de zoom ao mapa
    google.maps.event.addListener(this.map, 'zoom_changed', () => {
      /** Variável que armazena o zoom atual **/
      let mapZoom = this.map.getZoom();

      /** Variável que armazena o zoom em que a label vai ser exibida **/
      let labelController = mapZoom >= 14; // Zoom maior ou igual a 14

      /** Verifica se houve uma mudança no estado da label **/
      if (labelController !== labelVisible) {
        /** Atualiza o estado da label **/
        labelVisible = labelController;

        /** Percorre a lista com todos os markers de gateways **/
        this.gatewayMarkers.forEach((marker: google.maps.Marker) => {
          /** Caso o zoom seja maior ou igual a 14 **/
          if (labelVisible) {
            /** A label dos gateways é exibida **/
            marker.setLabel({
              text: '' + marker.getTitle(),
              color: 'black',
              fontSize: '12px',
              className: 'labels',
            });
            /** Caso contrário **/
          } else {
            /** A label dos gateways é removida **/
            marker.setLabel(null);
          }
        });
      }
    });

    /** Caso seja a empresa Iluminação Paulistana**/
    if (this.companyId === 'Q29tcGFueToxNg==') {
      /** Carrega o arquivo geoJson que contém as delimitações das subprefeituras de SP **/
      this.map.data.loadGeoJson(
        'assets/subprefeitura-map/subprefeituras.geojson',
      );

      /** Define as estilizações da delimitação **/
      this.map.data.setStyle((feature: any) => {
        const fillColor = feature.getProperty('fill');
        const fillOpacity = feature.getProperty('fill-opacity');

        /** Retorna com as propriedades que foram definidas e define o estilo que for padrão para todas as bordas **/
        return {
          fillColor: fillColor,
          fillOpacity: fillOpacity,
          strokeOpacity: 1,
          strokeWeight: 5,
          strokeColor: 'black',
        };
      });
    }

    /**
     * Salva a alteração no localStorage do navegador
     * para toda vez que trocar de página ou sair do sistema a preferência se manter
     * **/

    let currentTheme = this.themeDark ? 'modeDark' : 'modeLight';
    localStorage.setItem('Theme:', currentTheme);
  }

  /**
   * essa função será responsável por inicializar o mapa APÓS o script no html ter sido carregado
   */
  private initializeMapAfterScriptLoad() {
    // Cria o mapa levando em conta o tema salvo
    this.map = new google.maps.Map(document.getElementById('map')!, {
      zoom: 15,
      minZoom: 2,
      center: new google.maps.LatLng(-25.419736312579452, -49.26531751521734),
      styles: this.themeDark ? mapStyleDark : mapStyleLight,
      mapTypeControl: true, // false Remove os botões de tipo de mapa
      zoomControl: false, // Remover os botões de zoom
      fullscreenControl: false, // Remove o botão de tela cheia
    });

    /** Caso seja a empresa Iluminação Paulistana**/
    if (this.companyId === 'Q29tcGFueToxNg==') {
      /** Carrega o arquivo geoJson que contém as delimitações das subprefeituras de SP **/
      this.map.data.loadGeoJson(
        'assets/subprefeitura-map/subprefeituras.geojson',
      );

      /** Define as estilizações da delimitação **/
      this.map.data.setStyle((feature: any) => {
        const fillColor = feature.getProperty('fill');
        const fillOpacity = feature.getProperty('fill-opacity');

        /** Retorna com as propriedades que foram definidas e define o estilo que for padrão para todas as bordas **/
        return {
          fillColor: fillColor,
          fillOpacity: fillOpacity,
          strokeOpacity: 1,
          strokeWeight: 5,
          strokeColor: 'black',
        };
      });
    }

    // Filtra todas as divisões para poderem ser utilizadas como filtro de instalações
    this.getAllDivisions();

    // Filtra os contradores atraves do geoserver para aparecerem no mapa
    this.getGateways();

    // Objeto do poligono(Adicionado na tela assim que a polygonSlideToggle for alterada para true)
    this.polygon = new google.maps.Polygon({
      paths: this.polygonCoords, //Variavel responsavel por setar as coordenadas do poligono
      editable: true, // Permite ao usuário arrastar e redimensionar o círculo
      draggable: true, // Permite ao usuário arrastar o círculo
      strokeColor: 'rgba(65, 255, 10, 1)', // Cor da borda
      strokeOpacity: 0.8, // Opacidade da borda (0.0 - 1.0)
      strokeWeight: 2, // Espessura da borda em pixels
      fillColor: 'rgba(65, 255, 10, 1)', // Cor de preenchimento
      fillOpacity: 0.35, // Opacidade de preenchimento (0.0 - 1.0)
    });

    // adiciona listener para o evento click no mapa
    google.maps.event.addListener(this.map, 'click', () => {
      // Verifica se algum ponto foi selecionado antes
      if (this.selectedMarker) {
        //Desativa a animação
        this.selectedMarker.setAnimation(null);
        // fecha a janela de informações dos concentradores(Caso tenha)
        this.infoWindowGateway.close();
        // fecha a janela de informações das instalações(Caso tenha)
        this.infoWindowInstallation.close();
      }
    });

    // listener de duplo click no poligono(Mapeamento para excluir vertices)
    this.polygon.addListener('dblclick', (event: any) => {
      // Verificar se o clique ocorreu em uma das arestas do polígono
      if (
        google.maps.geometry.poly.isLocationOnEdge(event.latLng, this.polygon)
      ) {
        // Obter o caminho atual do polígono
        const path = this.polygon.getPath();

        // Encontrar a vértice mais próxima do local clicado
        let minDistance = Number.MAX_VALUE;
        let indexToRemove = -1;

        for (let i = 0; i < path.getLength(); i++) {
          const distance =
            google.maps.geometry.spherical.computeDistanceBetween(
              event.latLng,
              path.getAt(i),
            );
          if (distance < minDistance) {
            minDistance = distance;
            indexToRemove = i;
          }
        }

        // Remover a vértice do caminho (path) do polígono
        if (indexToRemove !== -1) {
          path.removeAt(indexToRemove);

          // Atualizar o polígono no mapa com o novo caminho (path) modificado
          this.polygon.setPath(path);
          this.updatePolygonPaths();
        }
      }
    });

    /** Variável utilizada para manipular quando a label deverá ser exibida **/
    let labelVisible = false;

    //Adiciona um ouvinte de evento de zoom ao mapa
    google.maps.event.addListener(this.map, 'zoom_changed', () => {
      const bounds = this.map.getBounds();

      /** Variável que armazena o zoom atual **/
      let mapZoom = this.map.getZoom();

      /** Variável que armazena o zoom em que a label vai ser exibida **/
      let labelController = mapZoom >= 14; // Zoom maior ou igual a 14

      /** Verifica se houve uma mudança no estado da label **/
      if (labelController !== labelVisible) {
        /** Atualiza o estado da label **/
        labelVisible = labelController;

        /** Percorre a lista com todos os markers de gateways **/
        this.gatewayMarkers.forEach((marker: google.maps.Marker) => {
          /** Caso o zoom seja maior ou igual a 14 **/
          if (bounds.contains(marker.getPosition()) && labelVisible) {
            /** A label dos gateways é exibida **/
            marker.setLabel({
              text: '' + marker.getTitle(),
              color: 'black',
              fontSize: '12px',
              className: 'labels',
            });
            /** Caso contrário **/
          } else {
            /** A label dos gateways é removida **/
            marker.setLabel(null);
          }
        });
      }
    });

    this.map.addListener('bounds_changed', () => {
      const bounds = this.map.getBounds();
      for (const marker of this.gatewayMarkers) {
        if (bounds.contains(marker.getPosition()) && labelVisible) {
          marker.setLabel({
            text: '' + marker.getTitle(),
            color: 'black',
            fontSize: '12px',
            className: 'labels',
          });
          if (marker.hasOwnProperty('label')) {
            marker.setZIndex(2);
          }
        } else {
          marker.setLabel(null);
        }
      }
    });

    // Obj infoWindow (Apresenta mais informações sobre as instalações)
    this.infoWindowInstallation = new google.maps.InfoWindow({
      content: ``, // Conteudo inicial vazio(Por não ter pontos vinculados a ela ainda)
      maxWidth: 300, // define a largura máxima da janela de informações para 200 pixels
    });

    // Obj infoWindow(Apresenta mais informações sobre os concentradores)
    this.infoWindowGateway = new google.maps.InfoWindow({
      content: ``, // Conteudo inicial vazio(Por não ter pontos vinculados a ela ainda)
      maxWidth: 250, // define a largura máxima da janela de informações para 200 pixels
    });

    // registra os enventos do google maps
    this.googleEventListeners();
  }

  /**
   *  funcao que registra os ouvintes de eventos do mapa.
   */
  private googleEventListeners() {
    // Intercepta o clique no botão 'mais informações' das instalações e inicia os eventos
    this.eventClickInstallation = google.maps.event.addListener(
      this.infoWindowInstallation,
      'domready',
      () => {
        document
          .getElementById('more-information')
          ?.addEventListener('click', () => {
            // Ação a ser executada quando o botão for clicado
            // habilita a sidebar de mais informações
            this.moreInfoController = true;
            // Faz a requisição de mais informações
            this.getMoreInformations(this.selectedMarker);
          });
      },
    );
    // Intercepta o clique no botão 'trazer instalações' dos concentradores e inicia os eventos
    this.eventClickGateway = google.maps.event.addListener(
      this.infoWindowGateway,
      'domready',
      () => {
        document
          .getElementById('get-installations')!
          .addEventListener('click', () => {
            // Fecha a sidebar de filtro
            this.closeEditionSideBar();
            // Fecha a sidebar de mais informações
            this.moreInfoController = false;
            // Reseta os dados de filtro
            this.filterForm.reset();

            this.gatewayInstallations = this.selectedMarker.get('macs')
              ? this.selectedMarker.get('macs')
              : [];

            if (this.gatewayInstallations.length > 0) {
              // Retira todas as instalações renderizadas no mapa
              this.markers.forEach((marker: google.maps.Marker) => {
                marker.setMap(null);
              });

              // Limpa a lista de instalações
              this.markers = [];

              // Limpa a lista da status e últimas trasmissões
              this.status_lastTransmission = {};

              this.paginateGatewayFilter(this.gatewayInstallations);
            } else {
              Swal.fire({
                icon: 'warning',
                title: this.translateService.instant(
                  'map.warning-no-results-label',
                ),
                text: this.translateService.instant(
                  'map.warning-no-results-text',
                ),
              });
            }
          });
      },
    );

    // adiciona listener para o evento closeclick da InfoWindow dos gateways
    this.eventCloseInfowindownGateway = this.infoWindowGateway.addListener(
      'closeclick',
      () => {
        // Se tiver marker selecionado, desativa a animação
        if (this.selectedMarker) {
          this.selectedMarker.setAnimation(null);
        }
      },
    );

    // adiciona listener para o evento closeclick da InfoWindow das instlações
    this.eventCloseInfowindownInstallation =
      this.infoWindowInstallation.addListener('closeclick', () => {
        // Encerra a requisição de tipos de equipamentos e de consumo
        this.subscriptionsEquipmentConsumption.unsubscribe();

        // Se tiver marker selecionado, desativa a animação
        if (this.selectedMarker) {
          this.selectedMarker.setAnimation(null);
        }
      });

    // Intercepta o clique no botão 'próxima instalação' das pétalas que se encontra no mesmo local e inicia os eventos
    this.eventClickNextInstallation = google.maps.event.addListener(
      this.infoWindowInstallation,
      'domready',
      () => {
        document
          .getElementById('next-instalation')
          ?.addEventListener('click', () => {
            if (
              this.currentInstallationIndex <
              this.samePlaceInstalations.length - 1
            ) {
              this.currentInstallationIndex++;
              // Ação a ser executada quando o botão for clicado
              this.getInfoWindowInstallation(
                this.samePlaceInstalations[this.currentInstallationIndex],
                this.samePlaceInstalations.length,
              );
            }
          });
      },
    );

    // Intercepta o clique no botão 'próxima instalação' das pétalas que se encontra no mesmo local e inicia os eventos
    this.eventClickPreviousInstallation = google.maps.event.addListener(
      this.infoWindowInstallation,
      'domready',
      () => {
        document
          .getElementById('previous-instalation')
          ?.addEventListener('click', () => {
            if (this.currentInstallationIndex > 0) {
              this.currentInstallationIndex--;
              // Ação a ser executada quando o botão for clicado
              this.getInfoWindowInstallation(
                this.samePlaceInstalations[this.currentInstallationIndex],
                this.samePlaceInstalations.length,
              );
            }
          });
      },
    );
  }

  /**
   * Atualiza em tempo real o status do gateway no mapa
   * escrevendo-se num canal websocket.
   * @param serialNumberList
   */
  private watchGatewaysFilter(serialNumberList: Array<string>): void {
    let token: string | null = localStorage.getItem('token');
    this.mapjsService.watchGatewaysRequest(serialNumberList, token);
  }

  /**
   *  Métodos relacionados aos markers do mapa em geral (Gateways e Equipamentos)
   *
   * **/

  /** Chave de cluster gravada no marker (evita divergência vs. getPosition() do Google Maps). */
  private clusterKeyForMarker(marker: google.maps.Marker): string {
    const stored = marker.get('cluster_key') as string | undefined;
    if (stored) return stored;
    const pos = marker.getPosition()!;
    return this.auditMapMarkerService.clusterKey(pos.lat(), pos.lng(), 0.00003);
  }

  // funçao para verificar instalações iguais ao marker selecionado e alterar caso seja diferente
  private countInstallation() {
    // Verifica se o marcador selecionado já está na lista
    const isSelectedMarkerInList = this.samePlaceInstalations.includes(
      this.selectedMarker,
    );

    if (!isSelectedMarkerInList) {
      const key = this.clusterKeyForMarker(this.selectedMarker);
      const samePlaceInstallations = this.markersByClusterKey.get(key) ?? [];
      // sort para sempre deixar o marker selecionando na primeira posição da lista
      let sortedInstallations = samePlaceInstallations.sort((a, b) => {
        if (a === this.selectedMarker) {
          return -1;
        } else if (b === this.selectedMarker) {
          return 1;
        } else {
          return 0;
        }
      });
      //atualiza as variaveis globais
      this.currentInstallationIndex = 0;
      this.samePlaceInstalations = sortedInstallations;
    }
  }

  //função que gera a janela de informações da instalação selecionada
  private getInfoWindowInstallation(marker: any, lengthIns: number) {
    this.countInstallation();

    //remove a animação do marker quando tem mais de um pétala na mesma lat e lng
    if (this.selectedMarker) {
      this.selectedMarker.setAnimation(null);
    }
    let equipmentInfo = this.status_lastTransmission[marker.get('device_mac')];
    marker.set(
      'last_transmission',
      equipmentInfo?.last_transmission ? equipmentInfo.last_transmission : null,
    );
    marker.set('status', equipmentInfo?.status == '1' ? true : false);

    // Formata os dados para a janela de informações(InfoWindown) do marker
    let gatewayReference = this.allGateways.find(
      (gateway) => gateway.id == marker.get('gateway_id'),
    );
    let divisionReference = this.allDivisions.find(
      (division) => division.id == marker.get('division_id'),
    );
    let application = marker.get('applications');
    let key = marker.get('has_magnetic_key') ? 'Possui chave' : 'Não possui';
    marker.set(
      'gateway_reference',
      gatewayReference ? gatewayReference!.reference : 'Não possui',
    );
    let division = divisionReference
      ? divisionReference!.reference
      : 'Não possui';
    let lastTransmission = marker.get('last_transmission')
      ? tzConvertUTC2LocalMap(marker.get('last_transmission'))
      : 'Não informado';
    let status = marker.get('status') ? 'Ligado' : 'Desligado';

    // Define o campo de status no infoWindow de acordo com a cor do ícone (sem tx ou ligado/desligado)
    if (marker.get('device_mac') == null) {
      status = 'Sem equipamento';
    } else if (marker.get('last_transmission') != null) {
      const transmissionTimeDiff = this.formatDatetime(
        marker.get('last_transmission')!,
      );

      if (transmissionTimeDiff! > 6 && transmissionTimeDiff! < 24) {
        status = 'Sem transmissão (+6h)';
      } else if (transmissionTimeDiff! > 24) {
        status = 'Sem transmissão (+24h)';
      }
    } else {
      status = 'Nunca transmitiu';
    }
    let additionalApplicationInfo = '';
    let applicationIcon = '';

    /** Atualiza o campo da propriedade de consumo com uma string de carregamento,
     * até que a requisição de consumo com os dados referente a medição sejam carregados e então atualizados **/
    this.individualConsumption = 'Carregando...';

    this.infoWindowInstallation.setContent(
      `
    <style>
      @import url('https://fonts.cdnfonts.com/css/ds-digital');
      .btn-outline-secondary:hover {

      color: white !important;
      }
    </style>

    <div class="consumption-text" style="display: flex; justify-content: center; flex-direction: column; font-family: "Play"; src: url("src\assets\fonts\Play-Regular.ttf");">
      <h1 style="font-size: 16px; color: #4c942a; font-weight: bold; width: 300px;">Informações do Equipamento</h1>

      ${lengthIns === 1
        ? `<h3 style="font-weight: bold;">${marker.getTitle()}</h3> `
        : `<div style="display: flex; justify-content: space-between; align-items: center;  flex-direction: row;">
            <button  id="previous-instalation" class="btn btn-light rounded-circle align-middle"  ${this.currentInstallationIndex === 0 ? 'disabled' : ''} >
              <img style="width: 1rem;"  src="../../../../assets/imgs/arrow_back.svg" alt="arrow_back">
            </button>
            <h3 style="font-weight: bold;" class="m-0">${marker.getTitle()}</h3>
            <button  id="next-instalation" class="btn btn-light rounded-circle align-middle ${this.currentInstallationIndex === lengthIns - 1 ? 'disabled' : ''}" >
              <img style="width: 1rem;" src="../../../../assets/imgs/arrow_right.svg" alt="arrow_next">
            </button>
          </div>
      `
      }

      <p style="font-weight: bold; font-size: 13px;"><b style="font-size: 14px; font-family:'Play'; src: url('src\assets\fonts\Play-Regular.ttf'); color: #4c942a;">STATUS</b>: ${status}</p>
      <p style="font-weight: bold; font-size: 13px;"><b style="font-size: 14px; font-family:'Play'; src: url('src\assets\fonts\Play-Regular.ttf'); color: #4c942a;">SUB DIVISÃO</b>: ${division}</p>
      <p style="font-weight: bold; font-size: 13px;"><b style="font-size: 14px; font-family:'Play'; src: url('src\assets\fonts\Play-Regular.ttf'); color: #4c942a;">CHAVE MAGNÉTICA</b>: ${key}</p>
      <p style="font-weight: bold; font-size: 13px;"><b style="font-size: 14px; font-family:'Play'; src: url('src\assets\fonts\Play-Regular.ttf'); color: #4c942a;">CONCENTRADOR</b>: ${marker.get('gateway_reference')}</p>
      <p style="font-weight: bold; font-size: 13px;"><b style="font-size: 14px; font-family:'Play'; src: url('src\assets\fonts\Play-Regular.ttf'); color: #4c942a;">ÚLTIMA TRANSMISSÃO</b>: ${lastTransmission} </p>
      ${additionalApplicationInfo}

      <button class="btn btn-success" id="more-information" style="width: 100%; margin-bottom: 8px;">MAIS INFORMAÇÕES</button>

      ${applicationIcon}

    </div>
  `,
    );

    // abre a janela de informações no marker
    this.infoWindowInstallation.open(this.map, marker);

    // Atualiza variavel com o marker selecionado
    this.selectedMarker = marker;

    // configura a animação do marker
    this.selectedMarker.setAnimation(google.maps.Animation.BOUNCE);
  }

  private makeMarkers(installations: any, type: string) {
    this.installationMacAddress = [];

    // Reconstrói completamente os markers
    let built = this.auditMapMarkerService.buildInstallationMarkers({
      installations,
      map: this.map,
      statusLastTransmission: this.status_lastTransmission,
      formatDatetime: (d) => this.formatDatetime(d),
      alertingInstallationReferences: this.alertingInstallations,
      clusterToleranceDegrees: 0.00003,
      hideAfterHours: 3,
      onClick: (marker) => {
        if (this.selectedMarker) this.selectedMarker.setAnimation(null);
        this.selectedMarker = marker;

        this.infoWindowGateway.close();
        this.infoWindowInstallation.close();

        const key = this.clusterKeyForMarker(marker);
        const group = this.markersByClusterKey.get(key) ?? [];

        this.getInfoWindowInstallation(marker, group.length || 1);
        this.subscriptionsEquipmentConsumption.unsubscribe();

        this.map.setOptions({
          center: new google.maps.LatLng(marker.getPosition()!),
          zoom: 18,
        });
      },
    });

    this.markers.push(...built.markers);
    this.installationMacAddress.push(...built.installationMacAddress);

    built.markersByClusterKey.forEach((markers, key) => {
      const existing = this.markersByClusterKey.get(key);
      if (existing) {
        existing.push(...markers);
      } else {
        this.markersByClusterKey.set(key, [...markers]);
      }
    });

    this.totalInstallations = built.totalVisibleInstallations;

    // Mantém comportamento anterior de clique direito (wheel + bounce + zoom)
    this.markers.forEach((marker) => {
      marker.addListener('rightclick', () => {
        if (this.selectedMarker) this.selectedMarker.setAnimation(null);
        marker.setAnimation(google.maps.Animation.BOUNCE);
        this.selectedMarker = marker;

        this.infoWindowGateway.close();
        this.infoWindowInstallation.close();

        this.map.setOptions({
          center: new google.maps.LatLng(marker.getPosition()!),
          zoom: 18,
        });
      });
    });

    this.filterFormsLoading = false;
    this.filterLoading = false;

    if (this.markers.length && !this.isRunning) {
      this.map.setOptions({
        center: new google.maps.LatLng(
          this.markers[this.markers.length - 1].getPosition()!,
        ),
        zoom: 15,
      });
    }
  }

  // Boolean responsavel por saber se o companyId pertence ou nao as roles permitidas para o usuario logado
  private userBelongsCompany(role: any) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(role, 'application/xml');
    const roles = Array.from(xmlDoc.getElementsByTagName('role')).map(
      (role) => role.textContent!,
    );

    // Verifica se o companyId está na lista de permissões, caso null, retorna valor true
    const hasPermission =
      this.companyId === null
        ? true
        : roles.includes(window.atob(this.companyId).replace(/\D/g, ''));
    return hasPermission;
  }

  private createGatewayMarker(gatewayInfo: any) {
    /** Variável utilizada p/ armazenar o caminho do ícone do gateway **/
    let urlImg: any;

    /** Subscrição para o subject que define quando o marker deverá ser atualizado p/ cor azul **/
    this.mapjsService.markerMapSubject$.subscribe((value) => {
      /** Caso o subject emita algum valor (true) **/
      if (value) {
        /** Define a cor dos markers dos gateways p/ azul **/
        urlImg = '../../../../assets/mark-icons/gateway-verde.png';
        /** Caso não emita nenhum valor **/
      } else {
        /** Define a cor dos markers dos gateways p/ preto **/
        urlImg = '../../../../assets/mark-icons/gateway-black.png';
      }
    });

    // Cria um marker para adicionar na lista posteriormente
    let marker: google.maps.Marker = new google.maps.Marker({
      position: {
        lat: gatewayInfo.geometry.coordinates[1],
        lng: gatewayInfo.geometry.coordinates[0],
      },
      icon: {
        url: urlImg,
        size: new google.maps.Size(55, 55),
        scaledSize: new google.maps.Size(55, 55),
      },
      title: gatewayInfo.properties.reference, // Define um título
      clickable: true, // Permite que o marker seja clicado
      map: this.map, // Adiciona o marker ao mapa
      zIndex: 2,
    });

    // Armazena os dados do concentrador em propriedades do marker
    marker.set('id', gatewayInfo.properties.id);
    marker.set('device_mac', gatewayInfo.properties.device_mac);
    marker.set('division_id', gatewayInfo.properties.division_id);
    marker.set(
      'device_serial_number',
      gatewayInfo.properties.device_serial_number,
    );
    marker.set('battery', gatewayInfo.properties.battery_status);

    // Adiciona o Listener de click no marker
    marker.addListener('click', () => {
      // Se algum marker foi selecionado antes é retirada a animação
      if (this.selectedMarker) {
        this.selectedMarker.setAnimation(null);
      }

      // Armazena a referência do concentrador
      let divisionReference = this.allDivisions.find(
        (division) => division.id === gatewayInfo.properties.division_id,
      );

      // Armazena a sub divisão do concentrador
      let division = divisionReference
        ? divisionReference!.reference
        : 'Não possui';

      // Puxa a última transmissão do gateway
      let lastTransmission = marker.get('lastTransmission')
        ? marker.get('lastTransmission')
        : 'Sem registro';

      // Puxa o total de instalações
      let totalInstallations = marker.get('num_installations')
        ? marker.get('num_installations')
        : 'Não informado';

      // Atualiza a variavel do marker selecionado
      this.selectedMarker = marker;

      // Fecha a janela de informações(Caso esteja aberta)
      this.infoWindowInstallation.close();

      const batteryStatus = marker.get('battery');
      const batteryIcon =
        batteryStatus == 'Charging'
          ? '⚡ |'
          : batteryStatus == 'Not charging'
            ? '🔋 |'
            : '';

      // Atualiza a InfoWindow
      this.infoWindowGateway.setContent(`
      <div
      style="display: flex; justify-content: center; flex-direction: column; font-family: "Play"; src: url("src\assets\fonts\Play-Regular.ttf");">
          <h1 style="font-size: 16px; color: #4c942a; font-weight: bold;">Informações do Concentrador</h1>
          <h3 style="font-weight: bold;">${batteryIcon} ${marker.getTitle()}</h3>
          <p style="font-weight: bold; font-size: 12px;"><span style="font-size: 14px; font-family:'Play'; src: url('src\assets\fonts\Play-Regular.ttf'); color: #4c942a;">NUMERO DE SÉRIE</b>: ${marker.get('device_serial_number')}</p>
          <p style="font-weight: bold; font-size: 12px;"><span style="font-size: 14px; font-family:'Play'; src: url('src\assets\fonts\Play-Regular.ttf'); color: #4c942a;">SUB DIVISÃO</b>: ${division}</p>
          <p style="font-weight: bold; font-size: 12px;"><span style="font-size: 14px; font-family:'Play'; src: url('src\assets\fonts\Play-Regular.ttf'); color: #4c942a;">TOTAL DE PONTOS</b>: ${totalInstallations}</p>
          <p style="font-weight: bold; font-size: 12px;"><span style="font-size: 14px; font-family:'Play'; src: url('src\assets\fonts\Play-Regular.ttf'); color: #4c942a;">Última transmissão</b>: ${lastTransmission}</p>
          <button
          class="btn btn-success"
          id="get-installations"
          >TRAZER INSTALAÇÕES</button>

      </div>`);

      // abre a janela de informações no marker
      this.infoWindowGateway.open(this.map, marker);

      // configura a animação do marker
      marker.setAnimation(google.maps.Animation.BOUNCE);

      // redefine as opções do mapa para os valores do marker selecionado
      this.map.setOptions({
        center: new google.maps.LatLng(marker.getPosition()!),
        zoom: 15,
      });
    });

    // Adicione o ouvinte de evento para o clique com botão direito no marcador
    marker.addListener('rightclick', () => {
      // Retira a animação do marker selecionado anteriormente
      if (this.selectedMarker) {
        this.selectedMarker.setAnimation(null);
      }

      // configura a animação do marker
      marker.setAnimation(google.maps.Animation.BOUNCE);

      // Atualiza a variavel do marker selecionado
      this.selectedMarker = marker;

      // Fecha a janela de infromações do concentrador
      this.infoWindowGateway.close();

      // Fecha a janela de informações da instalação
      this.infoWindowInstallation.close();

      // redefine as opções do mapa para os valores do marker selecionado
      this.map.setOptions({
        center: new google.maps.LatLng(marker.getPosition()!),
        zoom: 15,
      });
    });

    // redefine as opções do mapa para os valores do marker selecionado
    this.map.setOptions({
      center: new google.maps.LatLng(marker.getPosition()!),
      zoom: 10,
    });
    this.gatewayMarkers.push(marker);
  }

  /**
   *  Métodos relacionados aos gateways.
   * **/

  // Filtra os concentradores p/ serem renderizados no mapa
  private getGateways() {
    // Retira os concentradores renderizados do mapa
    this.gatewayMarkers.forEach((marker: google.maps.Marker) => {
      marker.setMap(null);
    });

    // Limpa a lista de concentradores
    this.gatewayMarkers = [];

    let serialNumberList: Array<string> = new Array<string>();

    this.mapjsService.isCompanyInRoles().subscribe({
      next: (role: any) => {
        // Verifica se o companyId está na lista de permissões
        const hasPermission = this.userBelongsCompany(role);
        if (hasPermission) {
          // Faz a requisição(Foi necessário fazer a conversão do companyId para decimal)
          this.subscriptions = this.mapjsService
            .getGateways(window.atob(this.companyId!))
            .subscribe({
              // Tratamento da resposta de sucesso
              next: (response: any) => {
                response.features.forEach((gateway: any) => {
                  // Armazena os concentradores para serem utilizados na renderização e manipulação do mapa
                  this.allGateways.push(
                    new Gateway(
                      gateway.properties?.id,
                      gateway.properties?.reference,
                      gateway.properties?.device_serial_number,
                    ),
                  );

                  this.createGatewayMarker(gateway);

                  if (
                    gateway.properties.device_serial_number != null &&
                    gateway.properties.device_serial_number != undefined
                  ) {
                    serialNumberList.push(
                      gateway.properties.device_serial_number,
                    );
                  }
                });

                this.watchGatewaysFilter(serialNumberList);
              },
              error: (error: any) => {
                console.log('Error on gateways query', error);
              },
            });
        } else {
          // Mostra uma mensagem de erro se o companyId não estiver na lista de roles
          Swal.fire({
            icon: 'error',
            title: this.translateService.instant(
              'map.error-access-denied-company-label',
            ),
            text: this.translateService.instant(
              'map.error-access-denied-company-text',
            ),
          });
        }
      },
      error: (error: any) => {
        // Mostra uma mensagem de erro se a chamada para obter permissões falhar
        Swal.fire({
          icon: 'error',
          title: this.translateService.instant(
            'map.error-permission-map-label',
          ),
          text: this.translateService.instant('map.error-permission-map-text'),
        });
        console.log('Error on permission check', error);
      },
    });
  }

  // Função responsável por manipular os ícones de concentrador de acordo com o status
  private gatewayStatusHandler(gatewayTransmission: GatewayManager) {
    const gatewayMarker = this.gatewayMarkers.findIndex((marker) =>
      this.compareGateways(gatewayTransmission.serialNumber, marker),
    );

    const ovpnTimeDiff = this.formatDatetime(
      gatewayTransmission.receivedDatetime?.toString()!,
    );

    const lastTransmission = tzConvertUTC2LocalMap(
      '' + gatewayTransmission.receivedDatetime,
    );

    let icon;

    // Caso seja encontrado um marker com o mesmo serial number da mensagem
    if (gatewayMarker != -1) {
      let icon;
      const ovpnTimeDiff = this.formatDatetime(
        gatewayTransmission.receivedDatetime?.toString()!,
      );
      const lastTransmission = tzConvertUTC2LocalMap(
        '' + gatewayTransmission.receivedDatetime,
      );

      this.gatewayMarkers[gatewayMarker].set(
        'lastTransmission',
        lastTransmission,
      );
      this.gatewayMarkers[gatewayMarker].set(
        'macs',
        gatewayTransmission.devices,
      );
      this.gatewayMarkers[gatewayMarker].set(
        'num_installations',
        gatewayTransmission.devices?.length,
      );
      this.gatewayMarkers[gatewayMarker].set(
        'transmission',
        gatewayTransmission,
      );
      this.gatewayMarkers[gatewayMarker].set(
        'battery',
        gatewayTransmission.batteryStatus,
      );

      /** Subscrição para o subject que define quando o marker do gateway deverá ser atualizado p/ cor verde **/
      this.mapjsService.markerMapSubject$.subscribe((value) => {
        /** Caso o subject emita algum valor (true) **/
        if (value) {
          /** Define a cor dos markers dos gateway p/ verde **/
          icon = {
            url: '../../../../assets/mark-icons/gateway-verde.png',
            size: new google.maps.Size(55, 55),
            scaledSize: new google.maps.Size(55, 55),
          };
          /** Se nenhum valor for emitido, a cor dos gateways permanecerão com o padrão. **/
        } else {
          // Lógica de verificação do ícone que será aplicado levando em conta apenas o status
          if (ovpnTimeDiff! > 12) {
            icon = {
              url: '../../../../assets/mark-icons/gateway-red-light-theme.png',
              size: new google.maps.Size(55, 55),
              scaledSize: new google.maps.Size(55, 55),
            };
            this.gatewayMarkers[gatewayMarker].set('status', 'offline');
          } else if (ovpnTimeDiff! >= 6 && ovpnTimeDiff! <= 12) {
            icon = {
              url: '../../../../assets/mark-icons/gateway-yellow.png',
              size: new google.maps.Size(55, 55),
              scaledSize: new google.maps.Size(55, 55),
            };
            this.gatewayMarkers[gatewayMarker].set('status', 'offline');
          } else {
            icon = {
              url: '../../../../assets/mark-icons/gateway-verde.png',
              size: new google.maps.Size(55, 55),
              scaledSize: new google.maps.Size(55, 55),
            };
            this.gatewayMarkers[gatewayMarker].set('status', 'online');
          }
        }
      });

      this.gatewayMarkers[gatewayMarker].setIcon(icon);
    }
  }

  // Filtra os concentradores p/ serem renderizados no mapa
  private filterGatewayIcon(gateways: any[]) {
    this.gatewayMarkers.forEach((marker) => {
      const selectedGateways = gateways.map(String);
      const isVisible = selectedGateways.includes(marker.get('id').toString());

      if (isVisible) {
        marker.setVisible(true);
      } else {
        marker.setVisible(false);
      }
    });
  }

  // Limpa o filtro e mostra os gateways novamente
  public resetGateways() {
    // Remove os markers do mapa
    this.markers.forEach((marker) => {
      marker.setMap(null);
    });

    this.markers = [];

    this.gatewayMarkers.forEach((marker) => {
      marker.setVisible(true);
    });
  }

  private compareGateways(messageSerial: any, marker: any) {
    const markerSerial = marker.get('device_serial_number');
    return markerSerial == messageSerial;
  }

  // Função criada para filtrar informações do gateway, até o momento só Status
  // Mas outros filtros podem ser adicionados nessa mesma função
  public filterGatewaysInfo() {
    let allGateways = this.gatewayMarkers;
    let selectedStatus = this.filterForm.value.gatewayStatus;

    if (this.filterForm.value.gatewayStatus) {
      allGateways = allGateways.filter((marker: google.maps.Marker) => {
        return marker.get('status') == selectedStatus;
      });
    }

    const filteredStatus = allGateways.map((marker: google.maps.Marker) =>
      marker.get('id'),
    );

    this.filterGatewayIcon(filteredStatus);
  }

  // Função que realiza o filtro no campo de concentradores da sidebar
  public filterGateways(searchTerm: any) {
    this.filteredGateways =
      this.auditMapFilterService.filterGatewaysBySearchTerm(
        this.allGateways,
        searchTerm,
      );
  }

  // Função para realizar o filtro das instalações do gateway (Usa o MAC para busca)
  private filterByGateway(gateways: any[]) {
    let geoURL = this.generateGeoserverURL();

    // Manipula a lista de macs para adicionar na URL da query
    const macsOnGateway = gateways.map((mac) => `'${mac}'`).join(', ');

    geoURL += `%20and%20device_mac%20IN%20(${macsOnGateway})`;

    this.lastQuery = geoURL;

    this.mapjsService.isCompanyInRoles().subscribe({
      next: (role: any) => {
        // Verifica se o companyId está na lista de permissões
        const hasPermission = this.userBelongsCompany(role);
        if (hasPermission) {
          //Solicita o filtro para o Geoserver com os parametros utilizados e a ultima empresa selecionada
          //Foi necessário a conversão do base64 pois o Geoserver não trabalha com hexadecimais
          this.subscriptions = this.mapjsService
            .filterByElements(geoURL, window.atob(this.companyId!))
            .subscribe({
              next: async (installations: any) => {
                this.refreshAlertingInstallationsCacheForInstallations();
                // Armazena o total de instalações
                this.totalInstallations = installations.features.length;

                // Verifica se o retorno do filtro será longo
                if (this.totalInstallations > 80000) {
                  // Envia uma msn de warning ao usuário
                  setTimeout(() => {
                    if (!this.isRunning) {
                      Swal.fire({
                        icon: 'warning',
                        title: this.translateService.instant(
                          'map.warning-filter-delay-label',
                        ),
                        text: this.translateService.instant(
                          'map.warning-filter-delay-text',
                        ),
                      });
                    }
                  }, 100);
                }

                // Se o filtro não retornar resultados é encerrada a aplicação
                if (this.totalInstallations === 0) {
                  this.filterLoading = false;
                  if (!this.isRunning) {
                    Swal.fire({
                      icon: 'warning',
                      title: this.translateService.instant(
                        'map.warning-no-results-label',
                      ),
                      text: this.translateService.instant(
                        'map.warning-no-results-text',
                      ),
                    });
                  }
                  return;
                }

                // Solicita o status e últimas trasmissões dos equipamentos filtrados
                await this.filterStatusAndLastTrasmission(
                  this.divideURLSearchParams(installations.features, 10000),
                  installations.features,
                  'installations',
                );
              },
              error: (error: any) => {
                this.filterLoading = false;

                // Envia uma msn de erro ao usuário
                if (!this.isRunning) {
                  Swal.fire({
                    icon: 'error',
                    title: this.translateService.instant(
                      'map.generic-error-label',
                    ),
                    text: this.translateService.instant(
                      'map.generic-error-text',
                    ),
                  });
                }

                console.log('Error on Installations filter', error);
              },
            });
        } else {
          // Mostra uma mensagem de erro se o companyId não estiver na lista de roles
          Swal.fire({
            icon: 'error',
            title: this.translateService.instant(
              'map.error-access-denied-company-label',
            ),
            text: this.translateService.instant(
              'map.error-access-denied-company-text',
            ),
          });
        }
      },
      error: (error: any) => {
        // Mostra uma mensagem de erro se a chamada para obter permissões falhar
        Swal.fire({
          icon: 'error',
          title: this.translateService.instant(
            'map.error-permission-map-label',
          ),
          text: this.translateService.instant('map.error-permission-map-text'),
        });
        console.log('Error on permission check', error);
      },
    });
  }

  // Função que realiza a paginação na requisição do botão de "Trazer-Instalações"
  private paginateGatewayFilter(macs: []): void {
    const paginationSize: number = 100;
    this.auditMapFilterService
      .chunk(macs as any[], paginationSize)
      .forEach((macsOnGateway) => this.filterByGateway(macsOnGateway));
  }

  // Função que realiza a paginação na requisição das rotas de cadastro
  private paginateInstallationsFilter(ids: []): void {
    const paginationSize: number = 100;
    this.auditMapFilterService
      .chunk(ids as any[], paginationSize)
      .forEach((page) => {
        this.filterStatusAndLastTrasmission(
          this.divideURLSearchParams(page, 10000),
          page,
          'installations',
        );
      });
  }

  // Função que retorna uma URL para a busca no geoserver de acordo com os filtros selecionados
  private generateGeoserverURL(): string {
    let built = this.auditMapFilterService.buildGeoserverURL(
      this.filterForm.value,
    );

    // Função criada para adicionar filtro de alertas
    // Deixei comentado caso solicitem novamente

    // // Verifica se o campo sub dibvisões foi utilizado
    // if (this.filterForm.value.alerts) {
    //   // Manipula a lista de macs para adicionar na URL da query
    //   const alertingMacs = Array.from(this.alertingInstallations.values())
    //     .map((mac) => `'${mac}'`)
    //     .join(', ');

    //   console.log(alertingMacs);

    //   built.url += `%20and%20device_mac%20IN%20(${alertingMacs})`;
    //   built.gatewayIdsToShow = [0];
    // }

    if (built.gatewayIdsToShow) {
      this.filterGatewayIcon(built.gatewayIdsToShow);
    }

    this.lastQuery = built.url;
    return built.url;
  }

  // Faz a paginação dos macs para o filtro de status e ultimas transmissões
  private divideURLSearchParams(
    params: any,
    maxSize: number,
  ): URLSearchParams[] {
    return this.auditMapFilterService.divideURLSearchParams(params, maxSize);
  }

  //Função chamada para filtros referentes aos campos(Referência, status, chave magnética, sub divisão e concentrador)
  public filterByElements() {
    // Verifica se o filtro por formas esta aplicado(caso esteja a operação é cancelada para não dar conflitos)
    if (this.filterFormsLoading) {
      return;
    }

    //Ativa o loading de carregamento
    this.filterLoading = true;

    let geoURL = this.generateGeoserverURL();

    this.mapjsService.isCompanyInRoles().subscribe({
      next: (role: any) => {
        // Verifica se o companyId está na lista de permissões
        const hasPermission = this.userBelongsCompany(role);

        if (hasPermission) {
          // Retira todas as instalações renderizadas no mapa
          this.markers.forEach((marker: google.maps.Marker) => {
            marker.setMap(null);
          });

          // Limpa a lista de instalações
          this.markers = [];

          //Solicita o filtro para o Geoserver com os parametros utilizados e a ultima empresa selecionada
          //Foi necessário a conversão do base64 pois o Geoserver não trabalha com exadecimais
          this.subscriptions = this.mapjsService
            .filterByElements(geoURL, window.atob(this.companyId!))
            .subscribe({
              next: async (installations: any) => {
                this.lastQuery = geoURL;

                // Armazena o total de instalações
                this.totalInstallations = installations.features.length;

                // Armazena as instalações da rota de cadastro
                this.registrationRouteInstallations.push(
                  installations.features,
                );

                // Verifica se o retorno do filtro será longo
                if (this.totalInstallations > 80000) {
                  // Envia uma msn de warning ao usuário
                  setTimeout(() => {
                    if (!this.isRunning) {
                      Swal.fire({
                        icon: 'warning',
                        title: this.translateService.instant(
                          'map.warning-filter-delay-label',
                        ),
                        text: this.translateService.instant(
                          'map.warning-filter-delay-text',
                        ),
                      });
                    }
                  }, 100);
                }

                // Se o filtro não retornar resultados é encerrada a aplicação
                if (this.totalInstallations === 0) {
                  this.filterLoading = false;
                  if (!this.isRunning) {
                    Swal.fire({
                      icon: 'warning',
                      title: this.translateService.instant(
                        'map.warning-no-results-label',
                      ),
                      text: this.translateService.instant(
                        'map.warning-no-results-text',
                      ),
                    });
                  }
                  return;
                }

                // Limpa a lista da status e últimas trasmissões
                this.status_lastTransmission = {};

                // Faz uma consulta de alertas (últimos 5 dias) e compara com o retorno do Geoserver
                await this.refreshAlertingInstallationsCacheForInstallations();

                this.paginateInstallationsFilter(installations.features);
              },
              error: (error: any) => {
                this.filterLoading = false;

                // Envia uma msn de erro ao usuário
                if (!this.isRunning) {
                  Swal.fire({
                    icon: 'error',
                    title: this.translateService.instant(
                      'map.generic-error-label',
                    ),
                    text: this.translateService.instant(
                      'map.generic-error-text',
                    ),
                  });
                }
                console.log('Error on Installations filter', error);
              },
            });
        } else {
          // Mostra uma mensagem de erro se o companyId não estiver na lista de roles
          Swal.fire({
            icon: 'error',
            title: this.translateService.instant(
              'map.error-access-denied-company-label',
            ),
            text: this.translateService.instant(
              'map.error-access-denied-company-text',
            ),
          });
        }
      },
      error: (error: any) => {
        // Mostra uma mensagem de erro se a chamada para obter permissões falhar
        Swal.fire({
          icon: 'error',
          title: this.translateService.instant(
            'map.error-permission-map-label',
          ),
          text: this.translateService.instant('map.error-permission-map-text'),
        });
        console.log('Error on permission check', error);
      },
    });
  }

  // Faz a requisição de consumo detalhado
  private getDetailConsuption(marker: google.maps.Marker) {
    // Aplica o loading na interface
    this.detailConsuptionLoading = true;

    // Faz a requisição a partir dos dados informados
    this.subscriptions = this.mapjsService
      .getDetailConsuption(btoa(`Installation:${marker.get('id')}`))
      .valueChanges.subscribe({
        // Tratamento da resposta de sucesso
        next: (response: any) => {
          // Desativa o loading
          this.detailConsuptionLoading = false;

          // Atualiza o endereço
          this.address = `${response?.data?.node?.site?.street}, ${response?.data?.node?.site?.number}. ${response?.data?.node?.site?.district}, ${response?.data?.node?.site?.city}`;

          // Atualiza o serial number
          this.serialNumber = response?.data?.node?.device?.serialNumber;
          this.lat = response?.data?.node?.site?.geoposition?.latitude;
          this.long = response?.data?.node?.site?.geoposition?.longitude;
        },
        error: (error: any) => {
          // Desativa o loading
          this.detailConsuptionLoading = false;

          // Informa uma mensagem de erro ao usuário
          this.errorLibService.errorAlert(error);
          console.log('Error on query DatailConsuption', error);
        },
      });
  }

  /**
   * Função traduz o tipo de comandos da tabela
   */

  // Trata os dados necessários e faz a requisição p/ completar os campos de mais informações
  private getMoreInformations(marker: google.maps.Marker) {
    // Limpa o endereço
    this.address = '';

    // Limpa o serial number
    this.serialNumber = '';

    // Limpa a lista de alertas
    this.alerts = [];

    // Armazena a geolocalização do marker
    this.lat = '';
    this.long = '';

    // Armazena a referencia do concentrador do marker
    this.gateway = marker.get('gateway_reference');

    // Faz a requisição consumo detalhado
    this.getDetailConsuption(marker);

  }

  // Fecha a aba de mais informações e e reseta o formulário de filtro
  public closeMoreInformation() {
    this.moreInfoController = false;
    this.filterForm.reset();
  }

  // Filtra todas as sub divisões p/ serem utilizadas como filtro
  private getAllDivisions() {
    this.subscriptions = this.mapjsService
      .getAllDivisions(this.companyId!)
      .valueChanges.subscribe({
        next: (divisions: any) => {
          divisions?.data?.division?.edges.forEach((division: any) => {
            this.allDivisions.push(
              new Division(
                window.atob(division?.node?.id).replace(/\D/g, ''),
                division?.node?.reference,
              ),
            );
          });
        },
        error: (error: any) => {
          this.errorLibService.errorAlert(error);
          console.log('Error on division query', error);
        },
      });
  }

  /**
   *
   * Métodos relacionados ao poligono
   *
   **/

  public filterByLatLong() {
    let url = `is_active=true%20and%20DWITHIN%20(geoposition,POINT(${this.filterForm.value.longitude + this.filterForm.value.latitude}),20,meters)`;

    this.urlFilter = url;

    // Habilita o o loading
    this.filterFormsLoading = true;

    // Limpa as instalações renderizadas no mapa
    this.markers.forEach((marker: google.maps.Marker) => {
      marker.setMap(null);
    });

    // Limpa a lista de instalações
    this.markers = [];

    this.lastQuery = url;

    this.mapjsService.isCompanyInRoles().subscribe({
      next: (role: any) => {
        // Verifica se o companyId está na lista de permissões
        const hasPermission = this.userBelongsCompany(role);
        if (hasPermission) {
          // Solicita o filtro ao Geoserver
          this.subscriptions = this.mapjsService
            .filterByLatLong(url, window.atob(this.companyId!))
            .subscribe({
              next: async (installations: any) => {
                // Armazena o total de instalações retornadas pela API

                this.totalInstallations = installations.features.length;

                // Caso o filtro não retorne conteúdo, exibe alerta ao usuário e aplicação é encerrada
                if (this.totalInstallations === 0) {
                  this.filterFormsLoading = false;
                  Swal.fire({
                    icon: 'warning',
                    title: this.translateService.instant(
                      'map.warning-no-results-label',
                    ),
                    text: 'Campos inválidos, favor informar os campos de latitude e longitude corretamente',
                  });
                  return;
                }

                // Limpa a lista da status e últimas trasmissões
                this.status_lastTransmission = {};

                await this.filterStatusAndLastTrasmission(
                  this.divideURLSearchParams(installations.features, 10000),
                  installations.features,
                  'installations',
                );
              },
              error: (error: any) => {
                console.log('Error on installations query', error);

                // Envia uma msn de erro ao usuário
                Swal.fire({
                  icon: 'error',
                  title: this.translateService.instant(
                    'map.generic-error-label',
                  ),
                  text: this.translateService.instant('map.generic-error-text'),
                });
                this.filterFormsLoading = false;
              },
            });
        } else {
          // Mostra uma mensagem de erro se o companyId não estiver na lista de roles
          Swal.fire({
            icon: 'error',
            title: this.translateService.instant(
              'map.error-access-denied-company-label',
            ),
            text: this.translateService.instant(
              'map.error-access-denied-company-text',
            ),
          });
          this.filterFormsLoading = false;
        }
      },
      error: (error: any) => {
        // Mostra uma mensagem de erro se a chamada para obter permissões falhar
        Swal.fire({
          icon: 'error',
          title: this.translateService.instant(
            'map.error-permission-map-label',
          ),
          text: this.translateService.instant('map.error-permission-map-text'),
        });
        console.log('Error on permission check', error);
        this.filterFormsLoading = false;
      },
    });
  }

  // Filtro por poligono
  public filterBypolygons(): any {
    this.installationsOnPolygons = true;

    if (
      this.filterForm.value.latitude ||
      (this.filterForm.value.longitude && !this.filterLoading)
    ) {
      this.filterByLatLong();
    } else {
      // Verifica se o filtro toggle esta habilitado e se não existe algum outro filtro em andamento
      if (this.polygonSlideToggle.value && !this.filterLoading) {
        // Cria a URL com as coordenadas do poligono
        let url = `is_active=true%20and%20WITHIN%20(geoposition,POLYGON((${this.formatPolygonCordinates(this.polygonCoords)})))`;
        this.urlFilter = url;

        // Habilita o o loading
        this.filterFormsLoading = true;

        // Limpa as instalações renderizadas no mapa
        this.markers.forEach((marker: google.maps.Marker) => {
          marker.setMap(null);
        });

        // Limpa a lista de instalações
        this.markers = [];

        this.lastQuery = url;

        this.mapjsService.isCompanyInRoles().subscribe({
          next: (role: any) => {
            // Verifica se o companyId está na lista de permissões
            const hasPermission = this.userBelongsCompany(role);
            if (hasPermission) {
              // Solicita o filtro ao Geoserver
              this.subscriptions = this.mapjsService
                .filterByPolygons(url, window.atob(this.companyId!))
                .subscribe({
                  next: async (installations: any) => {
                    // Armazena o total de instalações retornadas pela API
                    this.totalInstallations = installations.features.length;

                    // Caso o filtro não retorne conteúdo a aplicação é encerrada
                    if (this.totalInstallations === 0) {
                      this.filterFormsLoading = false;
                      return;
                    }

                    // Limpa a lista da status e últimas trasmissões
                    this.status_lastTransmission = {};

                    await this.filterStatusAndLastTrasmission(
                      this.divideURLSearchParams(installations.features, 10000),
                      installations.features,
                      'installations',
                    );
                  },
                  error: (error: any) => {
                    console.log('Error on installations query', error);

                    // Envia uma mensagem de erro ao usuário
                    Swal.fire({
                      icon: 'error',
                      title: this.translateService.instant(
                        'map.generic-error-label',
                      ),
                      text: this.translateService.instant(
                        'map.generic-error-text',
                      ),
                    });
                  },
                });
            } else {
              // Mostra uma mensagem de erro se o companyId não estiver na lista de roles
              Swal.fire({
                icon: 'error',
                title: this.translateService.instant(
                  'map.error-access-denied-company-label',
                ),
                text: this.translateService.instant(
                  'map.error-access-denied-company-text',
                ),
              });
            }
          },
          error: (error: any) => {
            // Mostra uma mensagem de erro se a chamada para obter permissões falhar
            Swal.fire({
              icon: 'error',
              title: this.translateService.instant(
                'map.error-permission-map-label',
              ),
              text: this.translateService.instant(
                'map.error-permission-map-text',
              ),
            });
            console.log('Error on permission check', error);
          },
        });
      }
      // Caso o poligono não esteja selecionado e os valores de rua/bairro estejam preenchidos
      else if (
        (!this.polygonSlideToggle.value && this.filterForm.value.street) ||
        this.filterForm.value.district
      ) {
        this.filterByElements();
        // Caso o poligono não esteja renderizado no mapa uma mensagem é mostrada
      } else if (!this.filterLoading) {
        Swal.fire({
          icon: 'warning',
          title: this.translateService.instant(
            'map.warning-polygon-filter-label',
          ),
          text: this.translateService.instant(
            'map.warning-polygon-filter-text',
          ),
        });
      }
    }
  }

  // Renderiza ou remove o poligono na tela
  public openPolygon() {
    this.polygonIsSelected = !this.polygonIsSelected;
    // Desabilita os campos de rua/bairro caso o filtro por poligono esteja ativo
    if (this.polygonIsSelected) {
      this.filterForm.controls['street'].disable();
      this.filterForm.controls['district'].disable();
      this.filterForm.controls['latitude'].disable();
      this.filterForm.controls['longitude'].disable();
    } else {
      this.filterForm.controls['street'].enable();
      this.filterForm.controls['district'].enable();
      this.filterForm.controls['latitude'].enable();
      this.filterForm.controls['longitude'].enable();
    }
    // Se o toggle for desmarcado o poligono é removido do mapa
    if (!this.polygonSlideToggle.value) {
      this.polygon.setMap(null);
    } else {
      // Adiciona o toggle no mapa
      this.polygon.setMap(this.map);

      // Pega as coordenadas do centro do mapa
      this.polygonCoords = this.getRandomLatLngs(this.map.getCenter());

      // Seta as coordenadas do poligono com o valor centralizado
      this.polygon.setPath(this.polygonCoords);

      // Adicione um ouvinte de evento para o evento 'set_at' que ocorre quando uma vértice é movida ou alterada
      google.maps.event.addListener(this.polygon.getPath(), 'set_at', () => {
        // Atualiza os valores dos vetices
        this.updatePolygonPaths();
      });

      // Adicione um ouvinte de evento para o evento 'insert_at' que ocorre quando uma nova vértice é adicionada
      google.maps.event.addListener(this.polygon.getPath(), 'insert_at', () => {
        // Atualiza os valores dos vertices
        this.updatePolygonPaths();
      });
    }
  }

  // formata as coordenadas (já calculadas) p/ string - será utilizada na requisição ao Geoserver pois o formato exigido é diferente do entregue pelo google.Maps
  private formatPolygonCordinates(coordinates: google.maps.LatLng[]): string {
    return this.auditMapFilterService.formatPolygonCoordinates(coordinates);
  }

  // Calcula o latLong do centro do mapa e aplica um valor de distância aleatório para dar forma ao poligono
  private getRandomLatLngs(centerLatLng: any) {
    // Definir um raio para gerar coordenadas aleatórias próximas ao centro (em graus)
    let radius = 0.02;

    // Armazena o nivel de zoom do mapa
    const zoomLevel = this.map.getZoom();

    // Verifica se o zoom possui aproximação maior ou igual a 15
    if (zoomLevel >= 15) {
      // Altera o tamanho polígono
      radius = 0.01;
    }

    // Armazena as coordenadas centrais do mapa
    const latCenter = centerLatLng.lat();
    const lngCenter = centerLatLng.lng();

    // Gera as coordenadas aleatórias(próximas ao centro)
    const latOffset = (Math.random() - 0.5) * radius * 2; // Número aleatório entre -radius e +radius
    const lngOffset = (Math.random() - 0.5) * radius * 2; // Número aleatório entre -radius e +radius

    const lat1 = latCenter + latOffset;
    const lng1 = lngCenter + lngOffset;

    const lat2 = latCenter + latOffset;
    const lng2 = lngCenter - lngOffset;

    const lat3 = latCenter - latOffset;
    const lng3 = lngCenter + lngOffset;

    const lat4 = latCenter - latOffset;
    const lng4 = lngCenter - lngOffset;

    // converte as coordenas para obj google.maps.LatLng
    const randomLatLng1 = new google.maps.LatLng(lat1, lng1);
    const randomLatLng2 = new google.maps.LatLng(lat2, lng2);
    const randomLatLng3 = new google.maps.LatLng(lat3, lng3);
    const randomLatLng4 = new google.maps.LatLng(lat4, lng4);

    return [randomLatLng4, randomLatLng2, randomLatLng1, randomLatLng3];
  }

  // Atualiza as coordenadas do poligono
  private updatePolygonPaths() {
    // Limpa as coordenadas anteriores
    let newCordinates = [];

    // Para cada vertice do poligo é criado um obj google.maps.LatLng(formato utilizado pelo google.Map)
    for (let i = 0; i < this.polygon.getPath().getLength(); i++) {
      const vertex = this.polygon.getPath().getAt(i);
      newCordinates.push(new google.maps.LatLng(vertex.lat(), vertex.lng()));
    }

    // Atualiza as coordenadas do poligono
    this.polygonCoords = newCordinates;
  }

  public selectLastQuery() {
    // Fecha o componente se estiver aberto
    this.selectedInstallationsView = false;
    // Remove  a instalação armazenada anteriormente
    localStorage.removeItem('selectedInstallations');
    // Armazena as instalações selecionadas
    this.selectedInstallations = localStorage.getItem('selectedInstallations')
      ? JSON.parse(localStorage.getItem('selectedInstallations')!)
      : [];

    this.mapjsService.isCompanyInRoles().subscribe({
      next: (role: any) => {
        // Verifica se o companyId está na lista de permissões
        const hasPermission = this.userBelongsCompany(role);
        if (hasPermission) {
          // Refaz o último filtro
          this.subscriptions = this.mapjsService
            .filterByElements(this.urlFilter, window.atob(this.companyId!))
            .subscribe({
              next: (response: any) => {
                response.features.forEach((feature: any) => {
                  // Verifica se a instalação já esta selecionada
                  if (
                    !this.selectedInstallations.some(
                      (installation) =>
                        installation.id === feature.properties.id,
                    )
                  ) {
                    // Mostra a barra de selecionados
                    this.selectedInstallationsView = true;

                    // Adiciona a instalação na lista de selecionados
                    this.selectedInstallations.push(
                      new Installation(
                        feature.properties.id,
                        feature.properties.reference,
                        feature.properties.device_mac,
                        true,
                      ),
                    );
                  }
                });

                //Armazena apenas as instalações com a propriedade check=true(Vai como marcado para o componente)
                this.selectedOptions = this.selectedInstallations.filter(
                  (installation: Installation) => installation.check === true,
                );

                // Salva as instalações marcadas
                localStorage.setItem(
                  'selectedInstallations',
                  JSON.stringify(this.selectedOptions),
                );
              },
              // Tratamento de erro
              error: (error: any) => {
                console.log('Filter instalations by geoserver', error);

                // Informa uma mensagem de erro ao usuário
                Swal.fire({
                  icon: 'error',
                  title: this.translateService.instant(
                    'map.generic-error-label',
                  ),
                  text: this.translateService.instant(
                    'map.error-select-installation-text',
                  ),
                });
              },
            });
        } else {
          // Mostra uma mensagem de erro se o companyId não estiver na lista de roles
          Swal.fire({
            icon: 'error',
            title: this.translateService.instant(
              'map.error-access-denied-company-label',
            ),
            text: this.translateService.instant(
              'permissions.error-access-denied-company-text',
            ),
          });
        }
      },
      error: (error: any) => {
        // Mostra uma mensagem de erro se a chamada para obter permissões falhar
        Swal.fire({
          icon: 'error',
          title: this.translateService.instant(
            'map.error-permission-map-label',
          ),
          text: this.translateService.instant('map.error-permission-map-text'),
        });
        console.log('Error on permission check', error);
      },
    });
  }

  // Fecha a sidebar de filtro
  public closeEditionSideBar() {
    this.filterController = false;
  }

  // Abre a sidebar de filtro e reseta o formulário
  public openSidebarEdit() {
    this.filterController = true;
    this.filterForm.reset();
  }

  /** Formatação do fuso horário **/
  private formatDatetime(datetimeString: any): number | null {
    // Transforma a string recebeida em um DateTime para manipulação pela Luxon
    let receivedDate = datetimeString;

    // Alguns casos a data vem com um espaço ao inves do T, porem a data continua válida.
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(receivedDate)) {
      receivedDate = receivedDate.replace(' ', 'T');
    }
    const formattedDate = DateTime.fromISO(receivedDate, { zone: 'utc' });
    // Pega o horário atual em UTC
    const nowTime = DateTime.utc();
    const differenceInHours = nowTime.diff(formattedDate, 'hours').hours;

    return differenceInHours;
  }

  //Funções do modo de demonstração

  // Fecha a sidebar de filtro
  public closeDemonstrationMode() {
    this.demonstrationController = false;
  }

  // Abre a sidebar de filtro e reseta o formulário
  public openDemonstrationMode() {
    this.demonstrationController = true;
    this.filterForm.reset();
  }

  //Função responsável por realizar os filtros do modo de demonstração
  public demonstrationMode() {
    if (this.isRunning) {
      this.delayInSeconds = this.demonstrationForm.value.delay
        ? this.demonstrationForm.value.delay
        : 8;

      if (this.index < this.gatewayMarkers.length) {
        // Adiciona as informações do gateway filtrado as variáveis exibidas no HTML
        this.selectedGateway =
          this.gatewayMarkers[this.index].get('transmission');
        this.gatewayName = '' + this.gatewayMarkers[this.index].getTitle();

        if (this.selectedGateway != undefined) {
          this.elementIsFound = true;
        }

        // Lista de macs que serão filtrados na hora de trazer os equipamentos comunicando pelo gateway
        const macsToFilter = this.gatewayMarkers[this.index].get('macs')
          ? this.gatewayMarkers[this.index].get('macs')
          : [];

        this.equipmentCount = macsToFilter.length;

        // Retira todas as instalações renderizadas no mapa
        this.markers.forEach((marker: google.maps.Marker) => {
          marker.setMap(null);
        });

        // Limpa a lista de instalações
        this.markers = [];

        // Limpa a lista da status e últimas trasmissões
        this.status_lastTransmission = {};

        // Define o gateway que deverá ser filtrado
        this.filterForm
          .get('gateway')
          ?.setValue([this.gatewayMarkers[this.index].get('id')]);
        // Filtra os pontos daquele gateway por rota de cadastro
        this.filterByElements();

        // Centraliza o mapa no cursor do gateway
        this.map.setOptions({
          center: new google.maps.LatLng(
            this.gatewayMarkers[this.index].getPosition()!,
          ),
          zoom: 15,
        });

        this.index++;
      } else {
        // Caso chegue ao fim da lista zera o index para recomeçar do 0
        this.index = 0;
      }
      // Timeout para fazer a requisição novamente todas as vezes
      setTimeout(() => {
        this.elementIsFound = false;
        this.demonstrationMode();
      }, this.delayInSeconds * 1000);
    }
  }

  // Função chamada ao clicar no botão de stop
  public stopDemonstration() {
    this.isRunning = false;
    this.index = 0;
    this.resetGateways();
  }

  // Função que da inicio ao modo de demonstração
  public startDemonstration() {
    this.isRunning = true;
    this.index = 0;
    this.resetGateways();
    this.demonstrationMode();
  }
}
